
import {
  IconCheckInCircle,
  IconCross,
  RevButton,
  RevButtonRounded,
  RevModal,
} from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'

import { MODAL_NAMES } from '@config/constants'
import RecommendationCrossSell from '@recommendation/components/RecommendationCrossSell/RecommendationCrossSell.vue'
import { ROUTES } from '@router'
import { trackClick } from '@tracking/events'

import translations from './AddToCartModal.translations'

export default {
  components: {
    IconCheckInCircle,
    RecommendationCrossSell,
    RevButton,
    RevButtonRounded,
    RevModal,
  },

  props: {
    accessories: {
      type: Array,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    listingId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    translations: () => translations,

    IconCross: () => IconCross,

    modalName: () => MODAL_NAMES.PRODUCT.ADD_TO_CART,

    formattedAccessories() {
      return this.accessories
        .map(({ text }) => text)
        .filter((text) => !isEmpty(text))
        .join(', ')
    },
  },
  methods: {
    handleAddToCartRedirect() {
      trackClick({
        name: 'go_to_cart',
        zone: 'add_to_cart_modal',
      })

      this.$navigation.push({
        type: 'internal',
        name: ROUTES.CHECKOUT.CART,
      })
    },

    handleClose(close) {
      trackClick({
        name: 'continue_shopping',
        zone: 'add_to_cart_modal',
      })

      close()
    },
  },
}
